import React from 'react'

const BlueLeftArrow14pxSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.39636 2.69038C9.19755 2.49709 8.87521 2.49709 8.6764 2.69038L4.60367 6.64997C4.5082 6.74279 4.45456 6.86869 4.45456 6.99996C4.45456 7.13122 4.5082 7.25712 4.60367 7.34994L8.6764 11.3095C8.87521 11.5028 9.19755 11.5028 9.39636 11.3095C9.59517 11.1162 9.59517 10.8029 9.39636 10.6096L5.68362 6.99996L9.39636 3.39034C9.59517 3.19705 9.59517 2.88367 9.39636 2.69038Z" fill="#3B82F6" />
        </svg>
    )
}

export default BlueLeftArrow14pxSvg